<template>
    <Button :label="label" :pt="{ loadingIcon: { class: 'mr-2' } }" :type="type" @click="buttonClick"/>
</template>

<script lang="ts" setup>
import {ref} from 'vue';
import Button from 'primevue/button';

const loading = ref(false);

const props = defineProps<{
    label: string,
    type: 'submit' | 'reset' | 'button';
}>();

const emit = defineEmits<{ (e: 'clicked'): void }>();

function buttonClick() {
    if (props.type === 'submit') return;
    loading.value = true;
    emit('clicked')
}
</script>
